import { Button, useTheme } from '@mui/material';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { StripeLogoVector } from 'apps/app/src/components/vectors/StripeLogoVector';
import React from 'react';

type StripeButtonProps = { 
  isConnected: boolean;
  disabled?: boolean;
  onConnectClick: () => void;
};

export const StripeButton: React.FC< StripeButtonProps> = ({ isConnected, disabled, onConnectClick }) => {
  const vyTheme = useTheme();

  return (
    <div
      className="flex items-center justify-between gap-2"
      key="Stripe"
    >
      <div className="flex items-center gap-3">
        <ColorDot color={isConnected ? vyTheme.palette.success.main : vyTheme.palette.grey[300]}/>
        <div className="flex h-12 w-16 items-center justify-center">
          <StripeLogoVector/>
        </div>
        <p>Stripe</p>
      </div>
      {isConnected ? (
        <Button
          color='error'
          variant='outlined'
          size='small'
        >
          Disconnect
        </Button>
      ) : (
        <Button
          disabled={disabled}
          color='success'
          variant='outlined'
          size='small'
          onClick={onConnectClick}
        >
          Connect
        </Button>
      )}
    </div>
  );
};